import React, { useMemo } from "react";
import { FlyerDetailPagePreviewPositionProps } from "./flyer-detail-page-preview-position.props";
import { FlyerDetailPageDetailPositionCell } from "./flyer-detail-page-preview-position.styles";
import cx from "classnames";
import { FlyerDetailPagePreviewPositionEmpty } from "../flyer-detail-page-preview-position-empty/flyer-detail-page-preview-position-empty.component";
import { FlyerDetailPagePreviewPositionDetails } from "../flyer-detail-page-preview-position-details/flyer-detail-page-preview-position-details.component";
import { FlyerDetailPagePreviewPositionLifestyle } from "../flyer-detail-page-preview-position-lifestyle/flyer-detail-page-preview-position-lifestyle.component";

export const FlyerDetailPagePreviewPosition = (props: FlyerDetailPagePreviewPositionProps) => {
  const pagePosition = useMemo(
    () =>
      props.pagePositions.find(
        (pagePosition) => pagePosition.templatePositionId === props.templatePosition.id
      ),
    [props.pagePositions, props.templatePosition]
  );

  const onEditPagePosition = () => {
    if (pagePosition) {
      props.onEditPagePosition(pagePosition.id);
    }
  };

  const templatePositionIsNotLifestyle = () => props.templatePosition.type !== "lifestyle";

  const noPagePosition = () => !pagePosition;

  const hasNoCategories = () =>
    pagePosition && (!pagePosition.categoryDetails || pagePosition?.categoryDetails.length === 0);

  const hasNoProducts = () =>
    pagePosition && (!pagePosition.products || pagePosition.products.length === 0);

  const shouldShowEmpty = () =>
    templatePositionIsNotLifestyle() &&
    (noPagePosition() || (hasNoCategories() && hasNoProducts()));

  const onClickEmpty = () => {
    if (pagePosition) {
      return props.onEditPagePosition(pagePosition.id);
    }
    return props.onCreatePagePosition();
  };

  return (
    <FlyerDetailPageDetailPositionCell
      rowSpan={props.templatePosition.rows}
      columnSpan={props.templatePosition.columns}
      className={cx({ active: props.active })}
    >
      <FlyerDetailPagePreviewPositionEmpty
        showIf={shouldShowEmpty()}
        label={props.templatePosition.label}
        onClick={onClickEmpty}
      />
      <FlyerDetailPagePreviewPositionDetails
        flyerEndDatePassed={props.flyerEndDatePassed}
        showIf={!shouldShowEmpty() && Boolean(pagePosition)}
        position={pagePosition!}
        language={props.language}
        templatePositionLabel={props.templatePosition.label}
        onClick={onEditPagePosition}
      />
      <FlyerDetailPagePreviewPositionLifestyle
        showIf={props.templatePosition.type === "lifestyle"}
      />
    </FlyerDetailPageDetailPositionCell>
  );
};
